import type { PlanDefinition } from "@medplum/fhirtypes";
import { VISIT_TITLE } from "@repo/domain";

export function protocolDisplayTitle(resource: PlanDefinition | undefined): string {
  return resource?.title ?? resource?.name ?? VISIT_TITLE;
}
